import { SearchQuery } from 'lib/models/searches/query';
import { SearchResults } from 'lib/models/searches/search-results';
import { BaseAPI } from '../base/base-api';

/**
 * Moderations API for searches.
 *
 * Using the v3 search endpoint.
 */
export class SearchesAPI extends BaseAPI {
  /**
   * Cache keys for React Query.
   */
  static keys = {
    all: (): (string | number | boolean | undefined | null)[] => {
      return ['mod', 'searches'];
    },
    search: (
      params: SearchQuery,
      offset: number = 0,
      limit: number = 10
    ): (string | number | boolean | undefined | null)[] => {
      return ['mod', 'searches', 'v3', 'search', params.key(), offset, limit];
    }
  };

  /**
   * Perform a search for diagnoses based on provided symptoms and findings.
   *
   * @param params Search parameters
   * @param previousResults The previous results (if any)
   * @param limit  The number of results to fetch
   * @returns
   */
  static async search(
    params: SearchQuery,
    offset: number = 0,
    limit: number = 20
  ): Promise<SearchResults> {
    const response = await this._post('/searches/query', {
      data: {
        ...params.toJson(),
        offset,
        limit
      }
    });

    console.log('Response from /searches/query: ', response);

    const json = await response.json();

    console.log('JSON from /searches/query: ', json);
    const searchResults = SearchResults.fromJson(json);

    console.log('SearchResults from /searches/query: ', searchResults);

    return searchResults;
  }
}
